import { useMemo } from 'react'
import ReactModal from 'react-modal'

import { TGetItemFn, TSelectLTPPage, TSetItemFn } from '@/config/types'
import { PageName } from '@/enums/pageName'
import { LTPPaymentScreenVersion } from '@/enums/paymentScreenVersion'

import { Close } from '@/shared/icons/Close'

import { LTPPaymentScreenModal } from '@/commonPages/paymentScreenLTPPage'
import {
  TPaymentScreenLTPPageOptions,
  TPaymentScreenLTPPageProps,
} from '@/commonPages/paymentScreenLTPPage/types'

export type TPaymentModalBlockProps = {
  modalId: string
  getItem: TGetItemFn
  setItem: TSetItemFn
  pageConfig: TSelectLTPPage
  paymentOptions?: TPaymentScreenLTPPageOptions
  closeModal: () => void
  openedModalId: string
}

const paymentScreenMap: Record<
  LTPPaymentScreenVersion.default,
  React.FunctionComponent<TPaymentScreenLTPPageProps>
> = {
  [LTPPaymentScreenVersion.default]: LTPPaymentScreenModal,
}

function getPaymentScreenComponent(): React.FunctionComponent<TPaymentScreenLTPPageProps> {
  return (
    paymentScreenMap[window.config.LTP_PAYMENT_SCREEN_VERSION as LTPPaymentScreenVersion] ||
    paymentScreenMap[LTPPaymentScreenVersion.default]
  )
}

export const LTPPaymentModalBlock = ({
  modalId,
  getItem,
  setItem,
  pageConfig,
  paymentOptions,
  openedModalId,
  closeModal,
}: TPaymentModalBlockProps) => {
  const { modalCloseDelay = 600, popupAppLogo } = pageConfig

  const PaymentPopupModalComponent = useMemo(() => getPaymentScreenComponent(), [])

  return (
    <ReactModal
      key={modalId}
      portalClassName="payment-modal-portal"
      overlayClassName="payment-modal-overlay"
      closeTimeoutMS={modalCloseDelay}
      className="payment-modal"
      ariaHideApp={false}
      shouldCloseOnOverlayClick={true}
      isOpen={openedModalId == modalId}
      id={modalId.toString()}
      onRequestClose={closeModal}
    >
      <button className="close-button" onClick={closeModal}>
        <Close />
      </button>
      {popupAppLogo && <div className="app-logo-container">{popupAppLogo}</div>}
      {paymentOptions && (
        <PaymentPopupModalComponent
          key={PageName.paymentScreen + `${modalId}`}
          getItem={getItem}
          setItem={setItem}
          config={window.config}
          {...paymentOptions}
          isAdditional={paymentOptions.isAdditional || false}
          isIntroOffer={paymentOptions.isIntroOffer || false}
        />
      )}
    </ReactModal>
  )
}
